import { render, staticRenderFns } from "./ChoixCompetenceRepeater.vue?vue&type=template&id=37fc4a5c&scoped=true"
import script from "./ChoixCompetenceRepeater.vue?vue&type=script&lang=js"
export * from "./ChoixCompetenceRepeater.vue?vue&type=script&lang=js"
import style0 from "./ChoixCompetenceRepeater.vue?vue&type=style&index=0&id=37fc4a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc4a5c",
  null
  
)

export default component.exports